import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "\n            d-flex\n            flex-column flex-root\n            position-absolute\n            min-w-100 min-h-100\n            justify-content-center\n            align-items-center\n        " }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = {
  target: "_blank",
  href: "https://multiorders.com"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Registration successful")
], -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Go to your Multiorders account ", -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createElementVNode("img", {
            alt: "Logo",
            src: _ctx.originUrl + _ctx.logo,
            class: "h-30px h-md-40px logo"
          }, null, 8, _hoisted_4)
        ])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          href: _ctx.originUrl + '/auth/login',
          id: "kt_sign_in_submit",
          class: "btn btn-lg btn-primary w-100 mb-5",
          target: "_blank"
        }, _hoisted_9, 8, _hoisted_7)
      ])
    ])
  ]))
}